"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ActionBarItemListItem = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["hasLink", "icon", "onClick", "className", "children"];
var ActionBarItemListItem = function ActionBarItemListItem(props) {
  var hasLink = props.hasLink,
    icon = props.icon,
    onClick = props.onClick,
    className = props.className,
    children = props.children,
    remainingProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var classes = (0, _classnames["default"])('ActionBarItemListItem', className);
  var iconClasses = (0, _classnames["default"])('ActionBarItemListItemIcon', 'rioglyph', icon);
  var btnClasses = (0, _classnames["default"])('ActionBarItemListItemButton');
  return /*#__PURE__*/_react["default"].createElement("li", (0, _extends2["default"])({}, remainingProps, {
    className: classes
  }), icon && /*#__PURE__*/_react["default"].createElement("span", {
    className: iconClasses
  }), hasLink && !onClick && /*#__PURE__*/_react["default"].createElement("span", null, children), onClick && /*#__PURE__*/_react["default"].createElement("div", {
    className: btnClasses,
    onClick: onClick
  }, children), !hasLink && !onClick && children);
};
exports.ActionBarItemListItem = ActionBarItemListItem;
ActionBarItemListItem.displayName = 'ActionBarItemListItem';
ActionBarItemListItem.propTypes = {
  hasLink: _propTypes["default"].bool,
  icon: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  className: _propTypes["default"].string
};
var _default = ActionBarItemListItem;
exports["default"] = _default;